import { useLocation } from "react-router-dom";
import type { RoutePath } from "../types/content";

export function useActiveRoute() {
  const location = useLocation();

  return (path: RoutePath) => {
    if (path === "/") {
      return location.pathname === "/";
    }

    return location.pathname.startsWith(path);
  };
}
